import React from "react";

export default ({ type = "track", id }) => (
  <iframe
    title={id}
    src={`https://open.spotify.com/embed/${type}/${id}`}
    width="300"
    height="80"
    frameBorder="0"
    allowtransparency="true"
    allow="encrypted-media"
  />
);



// WEBPACK FOOTER //
// ./src/components/SpotifyEmbed.js